import { render, staticRenderFns } from "./Skills.vue?vue&type=template&id=5e587c98&scoped=true&"
import script from "./Skills.vue?vue&type=script&lang=js&"
export * from "./Skills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e587c98",
  null
  
)

export default component.exports